import React from 'react';
import { shape, string } from 'prop-types';
import BaseTile from 'components/tiles/BaseTile';
import BgImgTile from 'components/tiles/BgImgTile';
import EventTile from 'components/tiles/EventTile';
import ContentImageTile from 'components/tiles/ContentImageTile';
import EventLargeTile from 'components/tiles/EventLargeTile';

export default function ListingItem({ item, tileType }) {
    // Determine which tile component gets rendered
    switch (tileType) {
        case 'bgImg':
            return (
                <BgImgTile item={item} />
            );
        case 'event':
            return (
                <EventTile item={item} />
            );
        case 'contentImage':
            return (
                <ContentImageTile item={item} />
            );
        case 'eventLarge':
            return (
                <EventLargeTile item={item} />
            );
        // add more below...
        default:
            return (
                <BaseTile item={item} />
            );
    }
}

ListingItem.propTypes = {
    item: shape({ title: string.isRequired }).isRequired,
    tileType: string.isRequired
};
